import type { HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

type CardProps = HTMLAttributes<HTMLDivElement> & {
  hoverable?: boolean
}

export function Card({ className, hoverable = false, ...props }: CardProps) {
  return (
    <div
      className={cn(
        'border border-slate-200 bg-white p-6 shadow-card transition-[transform,box-shadow,border-color] duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]',
        hoverable &&
          'group hover:-translate-y-1.5 hover:scale-[1.03] hover:border-brand/20 hover:shadow-float active:scale-[0.98]',
        className,
      )}
      {...props}
    />
  )
}
